import * as React from 'react';
import { Form, Header, Segment } from 'semantic-ui-react';

import FechaPago, { Datos as FechaPagoDatos, inicial as fechaPagoInicial } from './FechaPago';
import PresentaAbonoInicial from './PresentaAbonoInicial';

export interface Datos {
    numeroDeCuotas: number;
    fechaPago: FechaPagoDatos;
    presentaAbonoInicial: boolean;
}

export const inicial: Datos = {
    numeroDeCuotas: 10,
    fechaPago: { ...fechaPagoInicial },
    presentaAbonoInicial: false,
};

interface Props {
    pagare: Datos;
    onChange(pagare: Datos): void;
}

const cuotas = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const cuotasOptions = cuotas.map(numero => ({
    key: numero,
    value: numero,
    text: numero.toString(),
}));

const Pagare: React.FunctionComponent<Props> = props => {
    const { pagare, onChange } = props;

    return (
        <div>
            <Header as='h3'>Pagaré</Header>
            <Segment>
                <Form.Group widths='2'>
                    <Form.Select
                        label='N° de cuotas'
                        placeholder='Seleccione'
                        options={cuotasOptions}
                        value={pagare.numeroDeCuotas}
                        onChange={(_e, { value }) => {
                            onChange({ ...pagare, numeroDeCuotas: value as number });
                        }}
                    />
                </Form.Group>
                <FechaPago
                    fechaPago={pagare.fechaPago}
                    onChange={fechaPago => {
                        onChange({ ...pagare, fechaPago });
                    }}
                />
                <PresentaAbonoInicial
                    presentaAbono={pagare.presentaAbonoInicial}
                    onChange={presentaAbonoInicial => {
                        onChange({ ...pagare, presentaAbonoInicial });
                    }}
                />
            </Segment>
        </div>
    );
};

export default Pagare;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/FormasPago/componentes/Pagare.tsx